import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useCreateOrganization = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const createOrganizationHook = async (organization, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-event-organization/v1/create/`,
        {organization}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to create Organization");
      }
    } catch (error) {
      setError("An error occurred while creating Organization");
    } finally {
      setLoading(false);
    }
  };

  return [ createOrganizationHook, loading, error, success ];
};